import React from "react";
import { Img } from "../../Components/Img";
export const CategoriesWithIconSwiperCard = ({ iconUrl, iconAlt, label, href }) => (React.createElement("a", { href: href, className: "categories-with-icon-swiper-card" },
    React.createElement(Img, { src: iconUrl, alt: iconAlt }),
    React.createElement("p", null, label)));
